import {
  VaultStreamCallback,
  IndexerGrpcMitoStream,
  TransfersStreamCallback,
  VaultHolderSubscriptionStreamCallback
} from '@injectivelabs/sdk-ts'
import { MITO_API_ENDPOINT } from '@/app/utils/constant'
import { streamProvider } from '@/app/providers/StreamProvider'
import { StreamType } from '@/types'

export const mitoStream = new IndexerGrpcMitoStream(MITO_API_ENDPOINT)

export const cancelVaultStream = () => {
  streamProvider.cancel(StreamType.Vault)
}

export const streamVaultTransfers = ({
  callback,
  accountAddress
}: {
  accountAddress: string
  callback: TransfersStreamCallback
}) => {
  const streamFn = mitoStream.streamTransfers.bind(mitoStream)
  const streamFnArgs = {
    callback,
    account: accountAddress
  }

  streamProvider.subscribe({
    fn: streamFn,
    args: streamFnArgs,
    key: StreamType.VaultTransfers
  })
}

export const streamVault = ({
  callback,
  vaultAddress
}: {
  vaultAddress: string
  callback: VaultStreamCallback
}) => {
  const streamFn = mitoStream.streamVault.bind(mitoStream)
  const streamFnArgs = {
    callback,
    vault: vaultAddress
  }

  streamProvider.subscribe({
    fn: streamFn,
    args: streamFnArgs,
    key: StreamType.Vault
  })
}

export const streamVaultHolderSubscription = ({
  callback,
  holderAddress
}: {
  holderAddress: string
  callback: VaultHolderSubscriptionStreamCallback
}) => {
  const streamFn = mitoStream.streamVaultHolderSubscriptions.bind(mitoStream)
  const streamFnArgs = {
    callback,
    holderAddress
  }

  streamProvider.subscribe({
    fn: streamFn,
    args: streamFnArgs,
    key: StreamType.HolderSubscriptions
  })
}
